import { Component, ElementRef, inject } from '@angular/core';
import { SharedService } from '@core/services/shared.service';

@Component({
  selector: 'app-shared-service',
  template: '',
  standalone: true
})
export class SharedServiceComponent {
  constructor() {
    const element = inject(ElementRef);
    const sharedService = inject(SharedService);

    element.nativeElement.sharedServices = sharedService;
  }
}
